import React, { Component } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography';

import { getErrorString } from '../display/ErrorStrings';
import { withTranslation } from 'react-i18next';


class AchDispositionDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			errorString: '',
			notifyString: '',
			disposition: '',
			notes: ''
		};

		this.handleCancel = this.handleCancel.bind(this);
		this.handleOk = this.handleOk.bind(this);
	}

	handleDisp = name => event => {
		this.setState({ disposition: name })
	}

	handleNotes(e) {
		this.setState({ notes: e.target.value });
	}
	handleCancel(e) {
		e.preventDefault();
		this.props.onClosePopup(e);
	}

	handleOk(e) {
		e.preventDefault();
		if(this.props.viewOnly)
		{
			this.setState({ errorString: getErrorString('viewOnly.warning', 'Operation not allowed in support mode.') });
			return;
		}
		fetch("on_save_ach_exception",
			{
				method: 'POST',
				credentials: 'same-origin',
				headers:
				{
					'Accept': 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(
					{
						'transit': this.props.accountObject.transit,
						'account': this.props.accountObject.account,
						'id': this.props.item.id,
						'companyId': this.props.item.compId,
						'status': this.state.disposition,
						'notes': this.state.notes,
						'secureToken': this.props.secureToken
					}
				)
			}
		)
			.then(function (res) {
				if (!res.ok) {
					throw Error(res.status + " (" + res.statusText + ")");
				}
				return res;
			}).then(res => res.text())
			.then(text => {
				var reply = JSON.parse(text);
				if (!reply.authenticated) {
					this.props.history.push("/expired")
				}
				else if (reply.error) {
					this.setState({ errorString: reply.errorString })
				}
				else {
					this.props.onDispositionSave(this.state.disposition, this.state.notes)
				}

			})
			.catch(error => {
				this.setState({ errorString: getErrorString('general.server.status.error', 'The server responded with a status of ') + error.message })
				this.setState({ totalCount: 0 })
				this.setState({ viewPopup: true })
			});
	}

	componentDidMount() {
		let item = this.props.item;
		if (item.statusCode === 'R' || item.statusCode === 'D') {
			this.setState({ disposition: item.statusCode })
		}
		else {
			this.setState({ disposition: 'P' })
		}

	}



	render() {
		let { t } = this.props;
		return (
			<div >
				<Dialog style={{ textAlign: "center" }}
					open
					fullScreen={this.props.fullScreen}>
					<DialogTitle >{t('dispositionAch.label')}</DialogTitle>
					<DialogContent >
						<FormGroup row >
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.disposition === 'P'}
										onChange={this.handleDisp('P')}
										value="P"
										color="default"
									/>
								}
								label={t('pay.label')}
							/>
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.disposition === 'R'}
										onChange={this.handleDisp('R')}
										value="R"
										color="default"
									/>
								}
								label={t('return.label')}
							/>
						</FormGroup>
						<FormGroup row >
							<TextField
								margin="dense"
								id="notes"
								label={t('notes.label')}
								type='text'
								onChange={event => this.handleNotes(event)}
							/>
						</FormGroup>

					</DialogContent>
					<DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
						<Button onClick={this.handleOk} color="primary" >
							{t('save.button')}
						</Button>
						<span />
						<Button onClick={this.handleCancel} color="primary" >
							{t('cancel.button')}
						</Button>
					</DialogActions>
					{this.state.errorString.length > 0 &&
						<Typography style={{ paddingLeft: 10 }} color='error' variant='body1'> {getErrorString('general.error', 'ERROR: ') + this.state.errorString}</Typography>
					}
				</Dialog>
			</div>
		);
	}

}
export default withTranslation()(AchDispositionDetails);  
